export const EMPLOYMENT_STATUS = {
  child: "Child",
  student: "Student",
  employed: "Employed",
  unpaid_work: "Unpaid work",
  unemployed: "Unemployed",
  unable_to_work: "Unable to work due to medical condition",
  retired: "Retired",
};

export const HOME_STATUS = {
  homeless: "Homeless",
  alone_at_home: "Alone at home",
  with_partner: "With partner",
  with_family: "With family",
  with_friends: "With friends",
  in_residential_institution: "In residential institution",
  in_retirement_community: "In retirement community",
  in_nursing_home: "In nursing home",
};

export const HOME_SUPPORT = {
  independent: "Managing well. No extra support needed",
  aid: "Struggling a little. Additional support would be useful",
  assist: "Struggling a lot. Extra support essential",
};

// Advanced Health Care Directive
export const AHC_DIRECTIVE = {
  yes: "Yes",
  no: "No",
};

export const ALCOHOL_STATUS = {
  none: "None",
  less_than_one: "Less than 1 standard drink a day",
  one_to_two: "1-2 standard drinks a day",
  two_to_five: "2-5 standard drinks a day",
  five_to_ten: "5-10 standard drinks a day",
  more_than_ten: ">10 standard drinks a day",
};

export const SMOKE_STATUS = {
  none: "None",
  ex_smoker: "Ex-smoker",
  occasional: "Occasional",
  little: "Little (1-5 per day)",
  moderate: "Moderate (5-20 per day)",
  heavy: "Heavy (>20 per day)",
  yes: "Yes",
  no: "No",
};

export const DRUG_STATUS = {
  yes: "Used drugs",
  no: "Nil",
  decline: "Not specified",
};

// Overrides for the system label. If override value isn't given then default
// behavior is to split by '-' and start case. For example: "system-a" will
// show as "System A".
export const HEALTH_HIST_LABELS = {
  cardiac: "Heart",
  respiratory: "Lung",
  neurological: "Nerve/Brain",
  renal: "Kidney/Bladder",
  hepatic: "Liver/Gallbladder",
  endocrine: "Hormone/Diabetes",
  psychiatric: "Mental Health",
  musculoskeletal: "Muscle/Joint",
  hematological: "Blood Vessels/Blood Pressure",
  immunological: "Blood/Immune",
  intestinal: "Gut (stomach, intestine, bowel)",
  "mens-health": "Men's Health",
  "womens-health": "Women's Health",
  dermatological: "Skin",
};